import { api } from '../infrastructure/api'
import { appStore } from '../app/state'

export type SearchKind = 'equipment' | 'works' | 'parts'
export type SearchTab = 'all' | SearchKind

export interface SearchHit {
  kind: SearchKind
  id: string
  code: string
  title: string
  subtitle: string
}

export interface SearchResult {
  items: SearchHit[]
  groups: Record<SearchKind, SearchHit[]>
  counts: Record<SearchKind, number>
  total: number
  page: number
  pages: number
}

export const searchLabels: Record<SearchKind, string> = {
  equipment: 'Техника',
  works: 'Работы',
  parts: 'Детали',
}

export function search(q: string, tab: SearchTab = 'all', page = 1, signal?: AbortSignal) {
  const params = new URLSearchParams({ q: q.trim(), tab, page: String(page) })
  return api<SearchResult>('/search?' + params, { signal })
}

export function openSearchHit(hit: SearchHit, role = 'manager') {
  if (hit.kind === 'equipment') appStore.navigate(role === 'mechanic' ? 'mechanicFleet' : 'fleet', { id: hit.id })
  if (hit.kind === 'works') appStore.navigate('workorders', { id: hit.id })
  if (hit.kind === 'parts') appStore.navigate(role === 'mechanic' ? 'mechanicMaterials' : 'resources', { tab: 'catalog', item: hit.id })
}

export function searchHitHref(hit: SearchHit, role = 'manager') {
  const params = new URLSearchParams(hit.kind === 'parts' ? { tab: 'catalog', item: hit.id } : { id: hit.id })
  return (hit.kind === 'equipment' ? role === 'mechanic' ? '/m/fleet' : '/fleet' : hit.kind === 'works' ? '/works' : role === 'mechanic' ? '/m/materials' : '/materials') + '?' + params
}
